import React, { useRef, useState, useEffect } from "react";
import { Button, Modal, Toast } from '@themesberg/react-bootstrap';
import { EditAccountForm } from "./partials/EditAccountForm";
import { useCookies } from "react-cookie";
import { updateAccountAPI } from "../../../../../controller/api/account";

export default (props) => {
  const { accountData } = props;
  const [cookies] = useCookies(['lottmekong'])
  const [error, setError] = useState(false)

  const accountNameRef = useRef('')
  const accountNumberRef = useRef('')
  const bankRef = useRef(0)
  const nameRef = useRef('')

  // Initialize refs with existing data when modal opens
  useEffect(() => {
    if (accountData && props.show) {
      nameRef.current = accountData.name || '';
      accountNameRef.current = accountData.accountName || '';
      accountNumberRef.current = accountData.accountNumber || '';
      bankRef.current = accountData.bankId || 0;
    }
  }, [accountData, props.show]);

  const onNameChange = (text) => {
    nameRef.current = text
  }

  const onAccountNameChange = (text) => {
    accountNameRef.current = text
  }

  const onAccountNumberChange = (text) => {
    accountNumberRef.current = text
  }

  const onBankSelect = (id) => {
    bankRef.current = id
  }

  const validateEditAccount = () => {
    if (nameRef.current && accountNameRef.current && accountNumberRef.current && bankRef.current) {
      return true
    }
    return false
  }

  const onSubmit = async () => {
    if (validateEditAccount()) {
      const resp = await updateAccountAPI(
        cookies.lottmekong, 
        accountData.id,
        nameRef.current, 
        bankRef.current, 
        accountNameRef.current, 
        accountNumberRef.current
      )
      if (resp) {
        window.location.reload()
      } else {
        alert('Có lỗi xảy ra khi cập nhật tài khoản')
        return false
      }
    } else {
      setError(true)
    }
  }

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Sửa tài khoản
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Toast 
          className="d-inline-block m-1" 
          onClose={() => setError(false)} 
          show={error} 
          delay={3000} 
          autohide 
          bg='danger' 
          key={3} 
        >
          <Toast.Header>
            <strong className="me-auto">Lỗi</strong>
          </Toast.Header>
          <Toast.Body>Vui lòng điền đầy đủ thông tin</Toast.Body>
        </Toast>
        {accountData && (
          <EditAccountForm
            accountData={accountData}
            setBank={onBankSelect}
            setName={onNameChange}
            setAccountName={onAccountNameChange}
            setAccountNumber={onAccountNumberChange}
          />
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={props.onHide}>Hủy</Button>
        <Button variant="primary" onClick={onSubmit}>Cập nhật</Button>
      </Modal.Footer>
    </Modal>
  );
}
